import React from 'react';
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../itrust_common/components/AsyncComponent';

const PatientSurveys = asyncComponent(() =>
  import('../../containers/authorised/patientSurveys/PatientSurveys')
);

const PatientSurveysRoutes = (
  <Switch>
    <Route exact path="/patients-surveys" component={PatientSurveys} />
  </Switch>
);

export default PatientSurveysRoutes;